import {
	reduce,
	isUndefined,
	isNull,
	isArray,
	isEmpty
} from 'lodash';

export default {

	// https://github.com/jprichardson/string.js/blob/master/lib/string.js#L85
	capitalize: (str) => {
		return str.substr(0, 1).toUpperCase() + str.substring(1).toLowerCase();
	},

	// https://gist.github.com/TravelingTechGuy/32454b95a50d296912b9
	toQueryStringParameters: function(obj) {

		return reduce(obj, function(result, value, key) {

			if (!isNull(value) && !isUndefined(value)) {

				if (isArray(value)) {

					result += reduce(value, function(result1, value1) {

						if (!isNull(value1) && !isUndefined(value1)) {

							result1 += key + '=' + value1 + '&';
							return result1;

						} else {
							return result1;
						}

					}, '');

				} else {
					result += key + '=' + value + '&';
				}

				return result;

			} else {
				return result;
			}

		}, '').slice(0, -1);

	},

	toQueryString: function(queryString, object) {
		return ((queryString !== '?') ? '&' : '') + this.toQueryStringParameters(object);
	},

	makeQueryString: function(payload) {
		let queryString = '?';

		if (payload) {

			if (!isEmpty(payload.filter)) {
				queryString += this.toQueryString(queryString, payload.filter);
			}

			if (!isEmpty(payload.pagination)) {
				queryString += this.toQueryString(queryString, payload.pagination);
			}

		}

		if (queryString !== '?') {
			return queryString;
		}

		return '';

	}

};



// WEBPACK FOOTER //
// ./sources/support/string/index.js